import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { Nullable } from "@/types";

type State = {
    crmPath: Nullable<string>;
};

const initialState: State = {
    crmPath: null,
};

const slice = createSlice({
    name: "crm",
    initialState,
    reducers: {
        crmPathSetAction: (state: State, action: PayloadAction<Nullable<string>>) => {
            state.crmPath = action.payload;
        },
    },
});

export const { crmPathSetAction } = slice.actions;

export default slice.reducer;
